import React from 'react';

import { Design } from '../../../../../../viewer/elements/design';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { Asset } from '../../components/asset-blocks/asset';
import { DesignBody } from './design-body';
import { DesignHeader } from './design-header';

type Props = {
  asset: Design;
};

const DesignAsset = (props: Props) => {
  const [_, refresh] = useNonce();
  useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  React.useEffect(() => {
    props.asset.onMetadataChanged = refresh;

    return () => {
      props.asset.onMetadataChanged = undefined;
    };
  }, [props.asset, refresh]);

  React.useEffect(() => {
    props.asset.onVisibilityChanged = refresh;

    return () => {
      props.asset.onVisibilityChanged = undefined;
    };
  }, [props.asset, refresh]);

  return (
    <Asset asset={props.asset}>
      {{
        header: <DesignHeader asset={props.asset} />,
        content: <DesignBody asset={props.asset} refreshAsset={refresh} />,
      }}
    </Asset>
  );
};

export { DesignAsset, Props as DesignAssetProps };
